//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "../../api/common";
export default {
    data() {
        return {
            hospitaid: this.$route.query.hospitaid,
            // hospitaid: '201906041115491974d7b2046376d',
            patientid: '',
            orgInfo: {},
            photourl: '',
            expertList: [],
            doctorList: [],
            isShow: false,
            slid: '展开',
            hospitaname: ''
        }
    },
    methods: {
        //机构和医生信息
        getOrgInfo(){
            let params = {
                parameters: this.hospitaid,
                parametersone: this.patientid
            };
            this.$doRequest("/api/doctorhospital/queryorganizationanddoctor", params, res=>{
                this.orgInfo = res.hospitainlist[0];
                this.photourl = this.orgInfo.hospitalimage[0].photourl;
                res.doctorlist.forEach(item => {
                    if(item.doctorinfotype == 2){
                        this.expertList.push(item);
                    }else{
                        this.doctorList.push(item);
                    }
                });
                this.hospitaname = this.orgInfo.hospitaname;
            });
        },
        //展开关闭
        show(){
            if(this.isShow){
                this.slid = '展开';
                this.isShow = false;
            }else{
                this.slid = '收起';
                this.isShow = true;
            }
        },
        //去复诊
        gobuyService(row){
            this.$store.state.AllOfValue.doctorId = row.id;
            this.$store.state.sun.price = row.thagainpricefei;
            this.$router.push({ path: "/buyServiceDetails" });
        },
        //去挂号
        goMack(row){
            this.$store.state.AllOfValue.doctorId = row.id;
            this.$router.push({ path: "/orgMakeRegister", query: {hospitaid: this.hospitaid,hospitaname: this.hospitaname}});
        },
        init(){
            this.patientid = this.$store.state.userInfo.id;
            this.getOrgInfo();
        }
    },
    //生命周期之创建完成
    created: function() {
        document.title = '预约挂号';
        this.$isLogin(window.location.search.substr(1), this.init);
    }
}



// WEBPACK FOOTER //
// ./src/views/orgDetails/index.vue